export const MAIN_LOADING_SPINNER_ID = 'mainLoadingSpinnerElementId';
